import * as classnames from 'classnames'
import * as React from 'react'

import { IItemCard } from '../interface'

import ItemCardContentCommonWrapper from '../itemCardContentCommonWrapper'
import ItemCardLandscapePreview from '../itemCardLandscapePreview'
import ItemCardSidebar from '../itemCardSidebar'

import * as styles from './commonItemCardLayout.module.css'

interface IProps extends IItemCard {
  carousel?: boolean
}

class CommonItemCardLayout extends React.Component<IProps> {
  public render() {
    const { viewType, children, carousel = false } = this.props
    const rootClass = classnames(styles.root, {
      [styles.listView]: viewType === 'list',
      [styles.gridView]: viewType !== 'list'
    })

    return (
      <div className={rootClass}>
        <article className={styles.card}>
          <section className={styles.preview}>
            <ItemCardLandscapePreview carousel={carousel} {...this.props} />
          </section>
          <section className={styles.content}>
            <ItemCardContentCommonWrapper {...this.props}>
              {children}
            </ItemCardContentCommonWrapper>
          </section>
          <section className={styles.sidebar}>
            <ItemCardSidebar {...this.props} />
          </section>
        </article>
      </div>
    )
  }
}

export default CommonItemCardLayout
